// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__UxYpi","content":"hero_content__FfK4v","tagline":"hero_tagline__26XXN","subTagline":"hero_subTagline__vSCDW","ctaButton":"hero_ctaButton__OSSBt"};